import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["methodDetails", "targetReactions", "targetReactionItem", "targetTemplate", "stepRows", "stepRow", "stepNumber", "promptLevels", "promptLevelItem", "promptLevelTemplate", "ecSteps", "ecStepItem", "ecStepTemplate", "rsSteps", "rsStepItem", "rsStepTemplate"]
  static values = { newUrl: String }

  connect() {
    console.log("ProgramSkillForm controller connected")
  }

  // On skill change, reload the form (server-side) so blank config fields are
  // prefilled from the selected skill's defaults. Sends the current form values
  // so already-entered fields survive.
  skillChanged(event) {
    if (!this.hasNewUrlValue) return
    const frame = document.getElementById("program-skill-form")
    if (!frame) return

    const form = this.element.closest("form") || this.element
    const params = new URLSearchParams()
    new FormData(form).forEach((value, key) => {
      if (typeof value === "string") params.append(key, value)
    })
    frame.src = `${this.newUrlValue}?${params.toString()}`
  }

  // When teaching method changes, show/hide relevant fields
  async teachingMethodChanged(event) {
    const method = event.target.value
    console.log("Teaching method changed to:", method)

    if (!method) {
      this.methodDetailsTarget.innerHTML = ""
      return
    }

    // Fetch the partial for this teaching method
    try {
      const response = await fetch(`/teaching_methods/${method.toLowerCase()}_form`, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        this.methodDetailsTarget.innerHTML = html
      }
    } catch (error) {
      console.error("Error loading teaching method form:", error)
    }
  }

  addTargetReaction(event) {
    event.preventDefault()
    const html = this.targetTemplateTarget.innerHTML.replaceAll("NEW_RECORD", Date.now().toString())
    this.targetReactionsTarget.insertAdjacentHTML("beforeend", html)
  }

  removeTargetReaction(event) {
    event.preventDefault()
    const item = event.target.closest('[data-program-skill-form-target="targetReactionItem"]')
    if (!item) return
    const idField = item.querySelector('input[name*="[id]"]')
    if (idField) {
      const destroy = item.querySelector('[data-target-destroy]')
      if (destroy) destroy.value = "1"
      item.style.display = "none"
    } else {
      item.remove()
    }
  }

  addPromptLevel(event) {
    event.preventDefault()
    this.promptLevelsTarget.insertAdjacentHTML("beforeend", this.promptLevelTemplateTarget.innerHTML)
  }

  removePromptLevel(event) {
    event.preventDefault()
    const item = event.target.closest('[data-program-skill-form-target="promptLevelItem"]')
    if (item) item.remove()
  }

  addEcStep(event) {
    event.preventDefault()
    this.ecStepsTarget.insertAdjacentHTML("beforeend", this.ecStepTemplateTarget.innerHTML)
  }

  removeEcStep(event) {
    event.preventDefault()
    const item = event.target.closest('[data-program-skill-form-target="ecStepItem"]')
    if (item) item.remove()
  }

  addRsStep(event) {
    event.preventDefault()
    this.rsStepsTarget.insertAdjacentHTML("beforeend", this.rsStepTemplateTarget.innerHTML)
  }

  removeRsStep(event) {
    event.preventDefault()
    const item = event.target.closest('[data-program-skill-form-target="rsStepItem"]')
    if (item) item.remove()
  }

  // Add a new empty ladder step row
  addStep(event) {
    event.preventDefault()

    const row = document.createElement("tr")
    row.setAttribute("data-program-skill-form-target", "stepRow")
    row.innerHTML = `
      <td><span data-program-skill-form-target="stepNumber"></span></td>
      <td>
        <input type="text"
          name="program_skill[teaching_procedure][steps][][label]"
          value=""
          class="field-input w-full">
      </td>
      <td>
        <button type="button" class="btn btn-sm btn-ghost" style="color:var(--color-danger);"
          data-action="click->program-skill-form#removeStep">
          <i class="fa-solid fa-trash"></i>
        </button>
      </td>
    `
    this.stepRowsTarget.appendChild(row)
    this.renumberSteps()
  }

  // Remove a ladder step row (keep at least one)
  removeStep(event) {
    event.preventDefault()
    const row = event.target.closest('[data-program-skill-form-target="stepRow"]')

    if (this.stepRowTargets.length > 1) {
      row.remove()
    } else {
      const input = row.querySelector("input")
      if (input) input.value = ""
    }
    this.renumberSteps()
  }

  // Re-label the visible step numbers (1..N) after add/remove
  renumberSteps() {
    this.stepNumberTargets.forEach((el, i) => {
      el.textContent = i + 1
    })
  }
}
